module.exports = __webpack_public_path__ + "img/quest_report_task_selector_error.db38e252.svg";